module["exports"] = [
  "لورم",
  "ایپسوم",
  "متن",
  "ساختگی",
  "با،",
  "تولید",
  "سادگی",
  "نامفهوم،",
  "از",
  "صنعت",
  "چاپ",
  "و با",
  "استفاده",
  "از",
  "طراحان",
  "گرافیک",
  "است",
  "چاپگرها",
  "و متون",
  "بلکه",
  "روزنامه.",
  "و مجله",
  "در",
  "ستون",
  "و سطر",
  "آنچنان",
  "که،",
  "لازم",
  "است",
  "و برای",
  "شرایط",
  "فعلی",
  "تکنولوژی",
  "مورد نیاز",
  "و کاربردهای",
  "متنوع",
  "با هدف",
  "بهبود",
  "ابزارهای کاربردی",
  "می باشد",
  "کتابهای",
  "زیادی",
  "در",
  "شصت و سه درصد",
  "گذشته",
  "حال",
  "و آینده",
  "شناخت",
  "فراوان",
  "جامعه",
  "و",
  "متخصصان",
  "را",
  "می طلبد",
  "تا با،",
  "نرم افزارها",
  "شناخت",
  "بیشتری را",
  "برای",
  "طراحان",
  "رایانه ای",
  "علی الخصوص ",
  "طراحان خلاقی",
  "و فرهنگ پیشرو",
  "در زبان فارسی ",
  "ایجاد",
  "کرد",
  "در این صورت",
  "می توان",
  "امید",
  "داشت",
  "که",
  "تمام",
  "و دشواری",
  "موجود",
  "در",
  "ارائه",
  "راهکارها",
  "و",
  "شرایط",
  "سخت",
  "تایپ",
  "به پایان",
  " و زمان",
  "مورد نیاز",
  "شامل",
  "حروفچینی",
  "دستاوردهای",
  "اصلی",
  "و",
  "جوابگوی",
  "سوالات",
  "پیوسته",
  "اهل",
  "دنیای",
  "موجود",
  "طراحی",
  "اساسا",
  "مورد",
  "استفاده",
  "قرار گیرد"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/lorem/words.js
// module id = 2907
// module chunks = 1609